import { uniqBy } from 'lodash';

export const bodyStyleIds = ({ bodyStyles }) => bodyStyles.indexIds;

export const bodyStyle = ({ bodyStyles }, { bodyStyleId }) =>
  bodyStyles.byId[bodyStyleId];

export const bodyStyles = ({ bodyStyles }) => bodyStyles;

export const bodyStylesById = ({ bodyStyles }) => bodyStyles.byId;

export const seriesModelsForBodyStyle = (
  { models },
  { bodyStyleId, seriesId },
) => {
  const filteredModels = [];
  models.indexIds.forEach(modelId => {
    const model = models.byId[modelId];
    if (
      model.seriesId === seriesId &&
      (model.bodyStyleId === bodyStyleId || model.id === bodyStyleId)
    ) {
      filteredModels.push(model);
    }
  });

  return uniqBy(filteredModels, 'id');
};
